import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';
import {HomeComponent} from './home.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.landingHome.pageInRouting,
    data: {data: PAGES_AND_PATHS.landingHome},
    component: HomeComponent,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('./home.module').then(m => m.HomeModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
